module.exports = __webpack_public_path__ + "img/customer-service@1x.b20d752c.png";